import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  Switch,
  Alert,
  CircularProgress,
} from '@mui/material';
import { userSettingsApi } from '../services/userSettings';

const Settings: React.FC = () => {
  const [soleTrader, setSoleTrader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      const settings = await userSettingsApi.get();
      setSoleTrader(settings.soleTrader);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  const handleSoleTraderChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    setSoleTrader(newValue);
    setError(null);
    setSuccess(null);

    try {
      setSaving(true);
      await userSettingsApi.update({ soleTrader: newValue });
      setSuccess('Settings saved successfully');
      setTimeout(() => setSuccess(null), 3000);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to save settings');
      // Revert on error
      setSoleTrader(!newValue);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess(null)}>
          {success}
        </Alert>
      )}

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Timesheet Settings
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={soleTrader}
              onChange={handleSoleTraderChange}
              disabled={saving}
            />
          }
          label={
            <Box>
              <Typography variant="body1">Sole Trader Mode</Typography>
              <Typography variant="body2" color="textSecondary">
                When enabled, timesheets will be automatically approved when submitted.
                This is useful for single-user businesses where no manager approval is needed.
              </Typography>
            </Box>
          }
        />
      </Paper>
    </Box>
  );
};

export default Settings;







